import * as React from "react";
import type { SVGProps } from "react";

const SvgElistFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#375481"
      strokeWidth={2}
      transform="translate(1 1)"
    >
      <path strokeLinecap="round" d="M0 1.905h16M0 8h16M0 14.095h16" />
      <circle cx={5.714} cy={8} r={1.905} fill="#FFF" />
      <circle cx={10.286} cy={14.095} r={1.905} fill="#FFF" />
      <circle cx={10.286} cy={1.905} r={1.905} fill="#FFF" />
    </g>
  </svg>
);
export default SvgElistFilterIcon;
